export default [
  {
    path: '/apps/estabelecimento/list',
    name: 'apps-estabelecimento-list',
    component: () => import('@/views/cadastros/info-organizacionais/estabelecimento/list/Index.vue'),
    meta: {
      pageTitle: 'Estabelecimento',
    },
  },
];
